import httpService from "./httpService";
import utils from "./utils";

export default {
  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    var params = utils.merge(example, pageable);

    return httpService.get("vbOutgoingProcess", { params: params });
  },

  findById(id) {
    return httpService.get("vbOutgoingProcess/" + id);
  },

  findAllByFlowInstanceId(flowInstanceId) {
    let params = { flowInstanceId: flowInstanceId };
    return httpService.get("vbOutgoingProcess/findAllByFlowInstanceId", { params: params });
  },

  findUserVbOutgoingProcess(docId, pageable) {
    pageable = utils.initPageableParams(pageable);
    var params = utils.merge({ docId: docId }, pageable);

    return httpService.get("vbOutgoingProcess/findUserVbOutgoingProcess", {
      params: params
    });
  },

  chuyenXuLi(form, id) {
    return httpService.post("vbOutgoingProcess/chuyenXuLi/" + id, form);
  },

  ketThuc(form, id) {
    return httpService.post("vbOutgoingProcess/ketThuc/" + id, form);
  },

  // Phê duyệt rồi kết thúc luồng văn bản luôn không ban hành
  pheDuyetAndKetThuc(form, id) {
    return httpService.post("vbOutgoingProcess/ketThuc/thu-tuc/" + id, form);
  },

  tuChoi(form, id) {
    return httpService.post("vbOutgoingProcess/tuChoi/" + id, form);
  },

  tuChoiBanHanh(form, id) {
    return httpService.post("vbOutgoingProcess/tuChoiBanHanh/" + id, form);
  },

  markAsRead(vbOutgoingProcessId) {
    return httpService.post(
      "vbOutgoingProcess/markAsRead/" + vbOutgoingProcessId,
      null
    );
  },

  thuHoi(id, form) {
    return httpService.put("vbOutgoingProcess/" + id + "/thuHoi", form);
  },

  uploadImageSign(form) {
    return httpService.post("vbOutgoingProcess/uploadImageSign", form);
  },

  uploadImageSignViettel(form) {
    return httpService.post("vbOutgoingProcess/signTokenViettel", form);
  },

  exportFileBanHanh(id, form) {
    return httpService.post("vbOutgoingProcess/exportFileBanHanh/" + id, form);
  },

  findNotesForBanHanh(docId, flowInstanceId) {
    let params = { docId: docId, flowInstanceId: flowInstanceId };
    return httpService.get("vbOutgoingProcess/findNotesForBanHanh", { params: params });
  },

  banGiaoVb(form) {
    return httpService.post("banGiaoVb", form)
  }
};



// WEBPACK FOOTER //
// ./src/services/vbOutgoingProcessService.js